import { boot } from 'quasar/wrappers'
import 'echarts'
import VChart from 'vue-echarts'

import Fragment from 'components/base/Fragment.vue'
import DynamicZoom from 'components/base/DynamicZoom.vue'
import BaseContactNumber from 'components/base/form/BaseContactNumber.vue'
import BaseAddMore from 'components/base/form/BaseAddMore.vue'
import CallToAction from 'components/base/CallToAction.vue'
import EmptyListAlert from 'components/base/EmptyListAlert.vue'
import SettingCell from 'components/base/Setting/SettingCell.vue'
import SettingMenu from 'components/base/Setting/SettingMenu.vue'
import SettingPage from 'components/base/Setting/SettingPage.vue'
import BaseLandingList from 'components/base/BaseLandingList.vue'
import BaseActionMenu from 'components/base/BaseActionMenu.vue'
import BaseSidePanel from 'src/components/base/SidePanel/BaseSidePanel.vue'
import BaseSidePanelSection from 'src/components/base/SidePanel/BaseSidePanelSection.vue'
import BaseSidePanelRecord from 'src/components/base/SidePanel/BaseSidePanelRecord.vue'
import BaseSidePanelAddress from 'src/components/base/SidePanel/BaseSidePanelAddress.vue'
import BaseBranchSelection from 'src/components/base/BaseBranchSelection.vue'
import BaseTableHeaderInfo from 'src/components/base/Table/BaseTableHeaderInfo.vue'
import BaseTableHeaderSlider from 'src/components/base/Table/BaseTableHeaderSlider.vue'
import BaseTableDialog from 'src/components/base/BaseTableDialog.vue'
import BaseAvailability from 'src/components/base/Availability/BaseAvailability/BaseAvailability.vue'
import BaseBranchAvailability from 'src/components/base/Availability/BaseBranchAvailability/BaseBranchAvailability.vue'
import BasePopup from 'src/components/base/BasePopup.vue'
import BaseLottie from 'src/components/base/BaseLottie.vue'
import BaseUploader from 'src/components/base/BaseUploader/BaseUploader.vue'
import BaseFileUploader from 'src/components/base/BaseFileUploader/BaseFileUploader.vue'
import BaseGuard from 'src/components/base/BaseGuard.vue'
import BaseCSV from 'src/components/base/BaseCSV.vue'
import BaseToggleLine from 'src/components/base/BaseToggleLine.vue'
import BaseTemplateMain from 'src/components/base/BaseTemplate/components/main/BaseTemplateMain.vue'
import BaseTemplate from 'src/components/base/BaseTemplate/BaseTemplate.vue'
import BaseImagePreview from 'src/components/base/BaseImagePreview.vue'
import BaseOverlay from 'src/components/base/BaseOverlay.vue'
import BaseFormAttachment from 'src/components/base/BaseFormAttachment.vue'
import BaseAttachments from 'src/components/base/BaseAttachments.vue'
import BaseAiInsightCard from 'src/components/base/BaseAiInsightCard.vue'
import BaseFlexTable from '../components/base/BaseFlexTable.vue'
import BaseCarousel from '../components/base/BaseCarousel.vue'
import BaseJournalPopup from '../components/base/BaseJournalPopup.vue'
import BasePdfStyle from '../components/base/BasePdfStyle.vue'
import BaseItemDialog from '../components/base/BaseItemDialog/BaseItemDialog.vue'
import BaseAiButton from '../components/base/BaseAiButton.vue'

export default boot(({ app }) => {
  app.component('VChart', VChart)
  app.component('Fragment', Fragment)
  app.component('DynamicZoom', DynamicZoom)
  app.component('CallToAction', CallToAction)
  app.component('BaseContactNumber', BaseContactNumber)
  app.component('BaseAddMore', BaseAddMore)
  app.component('EmptyListAlert', EmptyListAlert)
  app.component('SettingCell', SettingCell)
  app.component('SettingMenu', SettingMenu)
  app.component('SettingPage', SettingPage)
  app.component('BaseLandingList', BaseLandingList)
  app.component('BaseSidePanel', BaseSidePanel)
  app.component('BaseSidePanelSection', BaseSidePanelSection)
  app.component('BaseSidePanelRecord', BaseSidePanelRecord)
  app.component('BaseSidePanelAddress', BaseSidePanelAddress)
  app.component('BaseActionMenu', BaseActionMenu)
  app.component('BaseBranchSelection', BaseBranchSelection)
  app.component('BaseTableHeaderInfo', BaseTableHeaderInfo)
  app.component('BaseTableHeaderSlider', BaseTableHeaderSlider)
  app.component('BaseTableDialog', BaseTableDialog)
  app.component('BaseAvailability', BaseAvailability)
  app.component('BaseBranchAvailability', BaseBranchAvailability)
  app.component('BasePopup', BasePopup)
  app.component('BaseLottie', BaseLottie)
  app.component('BaseUploader', BaseUploader)
  app.component('BaseFileUploader', BaseFileUploader)
  app.component('BaseGuard', BaseGuard)
  app.component('BaseCSV', BaseCSV)
  app.component('BaseToggleLine', BaseToggleLine)
  app.component('BaseTemplateMain', BaseTemplateMain)
  app.component('BaseTemplate', BaseTemplate)
  app.component('BaseImagePreview', BaseImagePreview)
  app.component('BaseOverlay', BaseOverlay)
  app.component('BaseFormAttachment', BaseFormAttachment)
  app.component('BaseAttachments', BaseAttachments)
  app.component('BaseAiInsightCard', BaseAiInsightCard)
  app.component('BaseFlexTable', BaseFlexTable)
  app.component('BaseCarousel', BaseCarousel)
  app.component('BaseJournalPopup', BaseJournalPopup)
  app.component('BasePdfStyle', BasePdfStyle)
  app.component('BaseItemDialog', BaseItemDialog)
  app.component('BaseAiButton', BaseAiButton)
})
